(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["facegym-mobile-menu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const readyClass = 'zaya-mobile-menu-ready';
    const openClass = 'zaya-mobile-menu-open';

    const closeNativeMenu = () => {
      const details = document.querySelector('#Details-menu-drawer-container');

      if (details) {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      }

      document.documentElement.classList.remove('overflow-hidden', 'overflow-hidden-mobile');
      document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile');
    };

    const initialize = (root) => {
      if (!root || root.dataset.zayaMenuInitialized === 'true') return;

      root.dataset.zayaMenuInitialized = 'true';
      document.documentElement.classList.add(readyClass);

      const controller = new AbortController();
      const { signal } = controller;
      const panel = root.querySelector('[data-zaya-menu-panel]');
      const openSelectors = root.dataset.openSelectors || '.header__icon--menu';
      let lastFocusedElement = null;
      let closeTimer = null;

      const getTrigger = (target) => {
        const element = target instanceof Element ? target : target?.parentElement;
        if (!element || root.contains(element)) return null;

        try {
          return element.closest(openSelectors);
        } catch (error) {
          return element.closest('.header__icon--menu');
        }
      };

      const openMenu = () => {
        clearTimeout(closeTimer);
        closeNativeMenu();
        lastFocusedElement = document.activeElement;
        root.classList.add('is-open');
        root.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add(openClass);
        document.body.classList.add(openClass);

        window.requestAnimationFrame(() => {
          const firstLink = panel.querySelector('a[href], summary, button:not([disabled])');
          (firstLink || panel).focus({ preventScroll: true });
        });
      };

      const closeMenu = (restoreFocus = true) => {
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove(openClass);
        document.body.classList.remove(openClass);
        closeNativeMenu();

        clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (restoreFocus && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
            lastFocusedElement.focus({ preventScroll: true });
          }
        }, 430);
      };

      const interceptTrigger = (event) => {
        const trigger = getTrigger(event.target);
        if (!trigger || !window.matchMedia('(max-width: 749px)').matches) return;

        if (
          event.type === 'click' &&
          (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
        ) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (!root.classList.contains('is-open')) openMenu();
      };

      window.addEventListener('pointerdown', interceptTrigger, { capture: true, signal });
      window.addEventListener('click', interceptTrigger, { capture: true, signal });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-zaya-menu-close]')) {
          closeMenu();
          return;
        }

        const link = event.target.closest('a[href]');
        if (link) closeMenu(false);
      }, { signal });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeMenu();
          return;
        }

        if (event.key !== 'Tab' || !root.classList.contains('is-open')) return;

        const focusable = Array.from(panel.querySelectorAll(
          'a[href], button:not([disabled]), summary, input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => !element.hidden && element.offsetParent !== null);

        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, { signal });

      root.zayaMenuDestroy = () => {
        controller.abort();
        clearTimeout(closeTimer);
        root.classList.remove('is-open');
        document.documentElement.classList.remove(openClass);
        document.body.classList.remove(openClass);

        if (document.querySelectorAll('[data-zaya-mobile-menu]').length <= 1) {
          document.documentElement.classList.remove(readyClass);
        }
      };
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-zaya-mobile-menu]').forEach(initialize);
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.querySelector('[data-zaya-mobile-menu]');
      if (root?.zayaMenuDestroy) root.zayaMenuDestroy();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
